import * as React from "react";
import { WithStyles, withStyles, createStyles, Theme } from 'components/controls/styles';
import Grid from '@material-ui/core/Grid';
import Checkbox from '@material-ui/core/Checkbox';
import Radio from '@material-ui/core/Radio';
import { PopisPlatby } from "./EditacePlatbyForm";

interface EditacePlatbyFormItemProps {
    title: string;
    pba: PopisPlatby;
    polovicni?: boolean;
    maxTrida?: number;
    jenPolovicniPlatby?: boolean;
    jeToSp?: boolean;
    jeToZcp?: boolean;
    updatePby: (p: PopisPlatby) => void;
}


class EditacePlatbyFormItem extends React.PureComponent<EditacePlatbyFormItemProps & WithStyles<typeof styles>> {

    render() {
        const { title, pba, polovicni, jeToSp, jeToZcp, maxTrida, updatePby, jenPolovicniPlatby, classes } = this.props;

        return <Grid item className={classes.root}>
            <Grid container direction="row" alignItems="center">
                <Grid item md={3}>{title + ': '}</Grid>
                {pba.hidden ? null : <Grid item md={9}>
                    {pba.neplatit
                        ? <span><Checkbox checked={false} disabled={true} />{' (jako čestný člen základní příspěvek neplatíte)'}</span> : pba.jizZaplaceno ? <span><Checkbox checked={true} disabled={true} />{'(již zaplaceno)'}</span>
                            : <Grid container direction="row" alignItems="center">
                                <Grid item md={1}><Checkbox checked={pba.checked === true} disabled={pba.musiPlatit} onChange={(e) => updatePby({ ...pba, checked: !pba.checked })} /></Grid>
                                {pba.musiPlatit && jeToSp && <Grid item md={11}>{'(správní poplatek se účtuje, protože platíte po 1. lednu)'}</Grid>}
                                {polovicni && pba.checked && <Grid item md={11}>
                                    <span><Radio checked={pba.polovicni !== true} onChange={e => updatePby({ ...pba, polovicni: e.target.checked ? false : true })} disabled={jenPolovicniPlatby} />{' celý (1.–12. měsíc)'}</span>
                                    <span><Radio checked={pba.polovicni === true} onChange={e => updatePby({ ...pba, polovicni: e.target.checked ? true : false })} />{' poloviční (7.–12. měsíc)'}</span>
                                </Grid>}
                                {maxTrida && pba.checked && <Grid item>
                                    {maxTrida >= 1 && (<span><Radio checked={pba.trida === 1} onChange={e => updatePby({ ...pba, trida: e.target.checked ? 1 : pba.trida })} />{' I. tř'}</span>)}
                                    {maxTrida >= 2 && (<span><Radio checked={pba.trida === 2} onChange={e => updatePby({ ...pba, trida: e.target.checked ? 2 : pba.trida })} />{' II. tř.'}</span>)}
                                    {maxTrida >= 3 && (<span><Radio checked={pba.trida === 3} onChange={e => updatePby({ ...pba, trida: e.target.checked ? 3 : pba.trida })} />{' III. tř.'}</span>)}
                                </Grid>}
                            </Grid>}
                </Grid>}
            </Grid>
        </Grid>;
    }
}


const styles = (theme: Theme) => createStyles({
    root: {
        display: 'flex'
    },
});


export default withStyles(styles)(EditacePlatbyFormItem);


